"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_reconciler_1 = __importDefault(require("react-reconciler"));
var reconciler = react_reconciler_1.default({
    now: Date.now,
    getRootHostContext: function () { return ({}); },
    prepareForCommit: function () { return ({}); },
    resetAfterCommit: function () { },
    getChildHostContext: function () { return ({}); },
    shouldSetTextContent: function () { return true; },
    createInstance: function () { },
    createTextInstance: function () { },
    appendInitialChild: function () { },
    appendChild: function () { },
    finalizeInitialChildren: function () { return false; },
    supportsMutation: true,
    appendChildToContainer: function () { },
    prepareUpdate: function () { return true; },
    commitUpdate: function () { },
    commitTextUpdate: function () { },
    removeChild: function () { },
    clearContainer: function () { },
    supportsPersistence: false,
    getPublicInstance: function (instance) { return instance; },
    preparePortalMount: function () { },
    isPrimaryRenderer: false,
    supportsHydration: false,
    scheduleTimeout: setTimeout,
    cancelTimeout: function (id) { return clearTimeout(id); },
    noTimeout: -1
});
function render(reactElement) {
    var container = reconciler.createContainer(null, 0, false, null);
    return reconciler.updateContainer(reactElement, container);
}
exports.render = render;
